import { isNumber } from './util'
import { helpers } from '@vuelidate/validators'
import { REGEX } from './constants'

export const isValidWidthUnit = (val: string | number): boolean => {
  if (isNumber(val)) {
    return true
  } else {
    return ['px', 'rem', 'em', 'vw', '%', 'vmin', 'vmax'].some(unit =>
      (val as string).endsWith(unit)
    )
  }
}

export const isValidComponentSize = (val: string) =>
  ['', 'large', 'medium', 'small', 'mini'].includes(val)

export const isValidPhoneNumber = helpers.regex(REGEX.PhoneNumber)
